<template>
  <div class="salesclerk-add">
    <div class="form">
      <van-form>
        <van-field
          v-model="form.nickname"
          label="店员姓名"
          placeholder="请输入店员姓名"
        />
        <van-field
          v-model="form.phone"
          type="number"
          maxlength="11"
          label="店员手机"
          placeholder="请输入店员手机"
        />
        <van-field
          readonly
          clickable
          :value="role"
          label="店员职务"
          placeholder="请选择店员职务"
          @click="showPicker = true"
        />
        <div class="tips">备注:店员添加成功后,默认密码为手机号后六位</div>
        <div class="process-btn">
          <van-button
            v-if="addBtn"
            type="primary"
            :loading="subStatus"
            @click="handleAddClerk"
          >
            确定添加
          </van-button>
          <van-button
            v-else
            type="primary"
            :loading="subStatus"
            @click="handleEdit"
          >
            保存修改
          </van-button>
        </div>
      </van-form>
    </div>
    <!-- 选择器 -->
    <!-- <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup> -->
  </div>
</template>

<script>
import { create, editClerk } from "@/api/clerk";
export default {
  data() {
    return {
      subStatus: false,
      addBtn: true,
      role: "维修工",
      form: {
        nickname: "",
        phone: "",
        role: 16
      },
      userInfo:  JSON.parse(sessionStorage.getItem("userInfo"))
    };
  },
  created() {
    let clerkData = JSON.parse(localStorage.getItem("clerkData"));
    if (clerkData) {
      this.addBtn = false;
      this.form = clerkData;
    }
  },
  methods: {
    // 添加店员
    handleAddClerk() {
      this.subStatus = true;
      if (!this.handleFormVerify()) {
        this.subStatus = false;
        return;
      }
      const data = {
        name: this.form.nickname,
        phone: this.form.phone,
        role: this.form.role,
      }
      create(data).then(res => {
        this.subStatus = false;
        if (res.code === 0) {
          this.$toast("添加成功");
          this.$router.replace("/clerk/salesclerkList");
        }
      });
    },
    // 修改店员
    handleEdit() {
      this.subStatus = true;
      if (!this.handleFormVerify()) {
        this.subStatus = false;
        return;
      }
      editClerk(this.form).then(res => {
        this.subStatus = false;
        if (res.code === 0) {
          this.$toast("修改成功");
          this.$router.replace("/clerk/salesclerkList");
          localStorage.removeItem("clerkData");
        }
      });
    },
    // 表单校验
    handleFormVerify() {
      if (!/[\u4e00-\u9fa5]/gm.test(this.form.nickname.trim())) {
        this.$toast("店员姓名请输入中文");
        return false;
      }
      if (
        this.form.phone.trim() === "" ||
        !/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
          this.form.phone.trim()
        )
      ) {
        this.$toast("请输入正确的手机号码");
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.salesclerk-add {
  .form {
    .tips {
      margin: 30px 0;
      font-size: 12px;
      color: #c0c0c0;
    }
  }
}
</style>
